import React, { useEffect } from "react";
import queryString from 'query-string';
import QRCode from 'qrcode.react';

// reactstrap components
import { Card, CardBody, Row, Col } from "reactstrap";


// services
import { showMessage } from "../../services/message.js";
import { api_GET } from "../../services/api_service.js";
import { formataValidade } from "../../helpers/formats";

//Context
import { useAuth } from "../../context/auth.js";

//Components
import LogoSistema from "../../components/LogoSistema/LogoSistema.jsx";

const montaEndereco = (obra) =>
    [obra?.logradouro, obra?.numero, obra?.complemento, obra?.bairro, obra?.cidade, obra?.uf]
        .filter(parte => !!parte)
        .join(", ");

const montaTransportador = (transportador) => {
    const identificacao = [transportador?.codigoCadastro, transportador?.razaoSocial]
        .filter(parte => !!parte)
        .join(" - ");

    return identificacao
        ? identificacao + " - " + (transportador?.cnpj ?? "")
        : (transportador?.cnpj ?? "") + " - cadastro não localizado";
};

export default function CarteirinhaRCC({ history }) {

    const { setLoading, setupSistema } = useAuth();

    const [dadoscarteirinha, set_dadoscarteirinha] = React.useState(null);

    const loadDados = () => {
        let urls = history.location.search;
        let params = queryString.parse(urls);

        if (!params.protocolo) {
            showMessage("Aviso", "Protocolo não informado.", 'error', null);
            return;
        }

        setLoading(true);
        api_GET('ProtocoloGerador/CarteirinhaRcc/' + encodeURIComponent(params.protocolo)).then(result => {
            if (["Cancelado", "Pendente", "Inativo"].includes(result.data?.status)) {
                if (result.data.status === "Inativo") {
                    showMessage("Aviso", "Cadastro Inativo no Sistema.", 'error', null);
                    return;
                } else {
                    showMessage("Aviso", "Carteirinha não disponível", 'error', null);
                    return;
                }
            }

            let carteirinha = result.data;

            let _carteirinha = {
                codCadastro: carteirinha?.codigoCadastro,
                validade: carteirinha?.dataFimVigencia,
                documento: carteirinha?.cpf_Cnpj ?? "",
                nome: carteirinha?.razaoSocial,
                enderecos: (carteirinha?.obras ?? []).map(montaEndereco).filter(endereco => !!endereco),
                transportadores: carteirinha?.transportadores ?? [],
                protocolo: carteirinha?.numeroProtocolo ?? params.protocolo,
            }
            set_dadoscarteirinha(_carteirinha);
        })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadDados();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // CPF tem 11 dígitos; acima disso o documento é CNPJ. Sem documento, o gerador é tratado
    // como pessoa jurídica, que é o caso do Grande Gerador RCC.
    const isPessoaFisica = dadoscarteirinha != null &&
        dadoscarteirinha.documento.length > 0 &&
        dadoscarteirinha.documento.length <= 11;

    const urlCarteirinha = (setupSistema?.urL_WEB_ROC ?? window.location.origin) +
        "/empty/CarteirinhaRCC?protocolo=" + encodeURIComponent(dadoscarteirinha?.protocolo ?? "");

    return (
        <>
            {dadoscarteirinha != null &&
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
                    <Card style={{ width: "15cm" }}>
                        <CardBody>
                            <div style={{ border: "1px solid black", padding: "0.5cm" }}>
                                <Row style={{ marginTop: "1cm" }}>
                                    <Col md="4">
                                        <LogoSistema identificacaoLogo={"logotipo"} width='100' />
                                    </Col>
                                    <Col md="4" className="text-center">
                                        <p>Grandes Geradores de Resíduos Inertes</p>
                                    </Col>
                                    <Col md="4" className="text-right">
                                        <LogoSistema identificacaoLogo={"logoSecundario"} width='130' />
                                    </Col>
                                    <Col md="6">
                                        <b>Nº de Cadastro: </b> <br />{dadoscarteirinha.codCadastro}
                                    </Col>
                                    <Col md="6">
                                        <b>Validade: </b> <br /> {formataValidade(dadoscarteirinha.validade)}
                                    </Col>
                                    {dadoscarteirinha.documento.length > 0 &&
                                        <Col md="12" className="mt-4">
                                            <b>{isPessoaFisica ? "CPF" : "CNPJ"}: </b> {dadoscarteirinha.documento}
                                        </Col>
                                    }
                                    <Col md="12" className={dadoscarteirinha.documento.length > 0 ? "" : "mt-4"}>
                                        <b>{isPessoaFisica ? "Nome" : "Razão Social"}: </b> {dadoscarteirinha.nome}
                                    </Col>
                                    {dadoscarteirinha.enderecos.map((endereco, index) => (
                                        <Col md="12" key={index}>
                                            <b>Endereço da Obra{dadoscarteirinha.enderecos.length > 1 ? `(${index + 1}):` : ":"} </b> {endereco}
                                        </Col>
                                    ))}
                                    {dadoscarteirinha.transportadores.length > 0 &&
                                        <Col md="12" className="mt-3">
                                            <b>Transportadores:</b>
                                            {dadoscarteirinha.transportadores.map((transportador, index) => (
                                                <div key={index}>
                                                    {montaTransportador(transportador)}
                                                </div>
                                            ))}
                                        </Col>
                                    }
                                </Row>
                                <Row>
                                    <Col md="12" className="text-center">
                                        <QRCode value={urlCarteirinha} />
                                    </Col>
                                </Row>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            }
        </>
    );
}
